import { TAG_SYSTEM } from '@/common/constants/tags.constants';

export default function hasSystemTag(tags: Array<string>): boolean {
  return tags?.indexOf(TAG_SYSTEM) > -1;
}
